import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import { NftTileMedia } from './NftTileMedia.tsx';
import { type NftItemTileMedia_item$key } from './__generated__/NftItemTileMedia_item.graphql.ts';

const itemFragment = graphql`
    fragment NftItemTileMedia_item on NftItem {
        serviceId
        importErrorReason
        metadata {
            ... on NftDigitalArtMetadata {
                media {
                    mimeType
                    webUrl
                    posterFrameUrl
                    videoThumb
                }
                name
            }
        }
    }
`;

export const NftItemTileMedia: FC<{
    item: NftItemTileMedia_item$key | null | undefined;
    animate: boolean;
    isMobile: boolean;
    showIcon: boolean;
    showSpinner?: boolean;
}> = ({ item: itemRef, animate, showIcon, showSpinner }) => {
    const { serviceId, metadata, importErrorReason } = useFragment(itemFragment, itemRef) ?? {};

    const { media, name } = metadata ?? {};
    const { mimeType, webUrl, videoThumb, posterFrameUrl } = media ?? {};

    return (
        <NftTileMedia
            animate={animate}
            mimeType={mimeType}
            webUrl={webUrl}
            videoThumb={videoThumb}
            posterFrameUrl={posterFrameUrl}
            altText={name}
            posterOverrideId={serviceId}
            showIcon={showIcon}
            isTransparent={!!importErrorReason}
            showSpinner={showSpinner}
        />
    );
};
